import React, { PropTypes } from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import ManifestationListItemContainer from '../../../containers/ManifestationListItemContainer';
import './ManifestationList.scss';

import BcReactComponent from '@bibliocommons/base-bc-react-component';

export class ManifestationList extends BcReactComponent {
  constructor(props) {
    super(props);
    this.bindAll('renderListings');
  }

  renderListings() {
    const { manifestations } = this.props;
    const singleItem = manifestations.count() === 1;
    return manifestations.map((item) =>
      <ManifestationListItemContainer
        item={item}
        key={item.get('id')}
        drawerOpen={singleItem} />
    );
  }

  render() {
    return (
      <div className="cp-manifestation-list">
        { this.renderListings()}
      </div>
    );
  }
}

ManifestationList.propTypes = {
  manifestations:            ImmutablePropTypes.list,
  availabilityDetail:        ImmutablePropTypes.map,
  availabilityDetailActions: PropTypes.objectOf(PropTypes.func),
  catalogSearchOptions:      ImmutablePropTypes.map,
  currentUser:               ImmutablePropTypes.map
};

ManifestationList.defaultProps = {
  manifestations: []
};

export default ManifestationList;



// WEBPACK FOOTER //
// ./app/components/search/ManifestationList/ManifestationList.jsx